export function getPlaceComponent(
  place: google.maps.places.PlaceResult,
  type: string,
  short: boolean = false,
): string {
  const comp = place.address_components?.find((c) => c.types.includes(type));
  if (!comp) return '';
  return short ? comp.short_name : comp.long_name;
}
